export enum INVITATION_SETTINGS {
  'ROLE' = 'role',
  'EMAIL' = 'email'
}
